<template>
  <div>
    <h4>{{ title }}</h4>
    <div class="row">
      <div class="col text-center" v-for="(icon, index) in extra" :key="index">
        <img :src="require('@/assets/icons/' + icon.icon + '-' + $store.getters.device(icon.serial)[icon.name] + '.png')" class="img-fluid" style="max-height: 100px;" :title="icon.icon + '; ' + icon.name + ' = ' + $store.getters.device(icon.serial)[icon.name]">
        <div>{{ icon.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'extra']
}
</script>
